import { PeriodEnum, PeriodEnumValues, PeriodLabels } from 'services/types/PeriodEnum';

export const PERIOD_OPTIONS = [
  { label: PeriodLabels.MONTTH, value: PeriodEnum.MONTTH, values: PeriodEnumValues.month },
  { label: PeriodLabels.QUATER, value: PeriodEnum.QUATER, values: PeriodEnumValues.quater },
  { label: PeriodLabels.YEAR, value: PeriodEnum.YEAR, values: PeriodEnumValues.year },
];
